module.exports = __webpack_public_path__ + "img/bosfor_bg.2912eae3.svg";